Jelly.Uploadcare = {
	Data_Key: "wf-uploadcare",
	Instance_Count: 0,

	Public_Key: function() {
		return window.WF_UPLOADCARE_PUBLIC_KEY || "ff137f8b093066d5ee4d";
	},

	Ready: function() {
		var Ready = window.WF_Uploadcare_File_Uploader_Ready;

		if (Ready && typeof Ready.then == "function") {
			return Ready.then(function() {
				return Jelly.Uploadcare.Wait_For_Custom_Elements();
			});
		}

		return Jelly.Uploadcare.Wait_For_Custom_Elements();
	},

	Wait_For_Custom_Elements: function() {
		if (!window.customElements || !customElements.whenDefined) {
			return Promise.reject(new Error("Uploadcare File Uploader requires custom elements support."));
		}

		return Promise.all([
			customElements.whenDefined("uc-config"),
			customElements.whenDefined("uc-upload-ctx-provider"),
			customElements.whenDefined("uc-file-uploader-regular")
		]);
	},

	Get: function(Input_Element) {
		return $(Input_Element).data(Jelly.Uploadcare.Data_Key);
	},

	SetValueFromUrl: function(Input_Element, URL, Options) {
		var Control = Jelly.Uploadcare.Initialize(Input_Element, Options || {});
		return Control.SetValueFromUrl(URL, Options || {});
	},

	Should_Load_Url_In_Browser: function(URL) {
		var Parsed_URL;

		if (!URL || !window.location) {
			return false;
		}

		try {
			Parsed_URL = new URL(URL, window.location.href);
		}
		catch (Error) {
			return false;
		}

		return Parsed_URL.origin == window.location.origin;
	},

	Get_File_Name_From_Url: function(URL, Blob) {
		var Parsed_URL;
		var File_Name = "upload";
		var Extension_By_Type = {
			"image/jpeg": ".jpg",
			"image/png": ".png",
			"image/gif": ".gif",
			"image/webp": ".webp"
		};

		try {
			Parsed_URL = new URL(URL, window.location.href);
			File_Name = Parsed_URL.pathname.split("/").pop() || File_Name;
		}
		catch (Error) {}

		if (Blob && Blob.type && Extension_By_Type[Blob.type] && File_Name.indexOf(".") == -1) {
			File_Name += Extension_By_Type[Blob.type];
		}

		return File_Name;
	},

	Initialize: function(Input_Element, Options) {
		var $Input = $(Input_Element);
		var Existing = $Input.data(Jelly.Uploadcare.Data_Key);

		if (Existing) {
			Existing.UpdateOptions(Options || {});
			return Existing;
		}

		var Control = Jelly.Uploadcare.Create_Control(Input_Element, Options || {});
		$Input.data(Jelly.Uploadcare.Data_Key, Control);
		return Control;
	},

	Create_Control: function(Input_Element, Options) {
		var $Input = $(Input_Element);
		var Context_Name;
		var $Wrapper;
		var $Config;
		var $Provider;
		var $Uploader;
		var Control;

		if (!Input_Element.id) {
			Jelly.Uploadcare.Instance_Count += 1;
			Input_Element.id = "WF_Uploadcare_Input_" + Jelly.Uploadcare.Instance_Count;
		}

		Context_Name = "wf-uploadcare-" + Input_Element.id.replace(/[^a-zA-Z0-9_-]/g, "-");
		$Wrapper = $("<span/>")
			.addClass("wf-uploadcare-uploader")
			.attr("data-uploadcare-context", Context_Name)
			.css({
				display: "block",
				position: "absolute"
			});

		$Config = $("<uc-config/>");
		$Provider = $("<uc-upload-ctx-provider/>");
		$Uploader = $("<uc-file-uploader-regular/>");

		$Provider.attr("ctx-name", Context_Name);
		$Uploader.addClass("wf-uploadcare-theme uc-light");
		$Uploader.attr({
			"ctx-name": Context_Name,
			"headless": ""
		});

			Control = {
				Input_Element: Input_Element,
				Options: {},
				Context_Name: Context_Name,
				Config_Element: $Config.get(0),
				Provider_Element: $Provider.get(0),
				Uploader_Element: $Uploader.get(0),
				SkipInitial: false,
				User_Flow_Active: false,
				Closing_Flow: false,
				Submitted_Internal_Id: null,
				Pending_Editor_File_Entry: null,
				Preload_Internal_Id: null,
				Decorator_Observer: null,
				Decorator_Interval: null,
				Decorator_Timeout: null,
				Api_Promise: null,

			UpdateOptions: function(New_Options) {
				this.Options = $.extend({}, this.Options, New_Options || {});
				Jelly.Uploadcare.Apply_Config(this);
			},

			GetApi: function() {
				var This_Control = this;

				if (!this.Api_Promise) {
					this.Api_Promise = Jelly.Uploadcare.Ready().then(function() {
						Jelly.Uploadcare.Bind_Events(This_Control);
						return This_Control.Provider_Element.getAPI();
					});
				}

				return this.Api_Promise;
			},

				Open: function() {
					var This_Control = this;

					this.User_Flow_Active = true;
					return this.GetApi().then(function(Api) {
						Api.initFlow();
						Jelly.Uploadcare.Start_Decorator(This_Control);
						return Api;
					});
				},

				Clear: function() {
					var This_Control = this;
					this.SkipInitial = false;
					this.User_Flow_Active = false;
					this.Submitted_Internal_Id = null;
					this.Pending_Editor_File_Entry = null;
					this.Preload_Internal_Id = null;
					Jelly.Uploadcare.Set_Editor_Auto_Open(this, false);
					Jelly.Uploadcare.Stop_Decorator(this);

					return this.GetApi().then(function(Api) {
						Api.removeAllFiles();
						$(This_Control.Input_Element).val("");
						return Api;
					});
				},

			SetSkipInitial: function(SkipInitial) {
				this.SkipInitial = !!SkipInitial;
				$(this.Input_Element).data("skip-initial", this.SkipInitial ? 1 : 0);
			},

				SetValueFromUrl: function(URL, Set_Options) {
					var This_Control = this;
					var Use_Cdn_Method = /(^|\/\/)([^\/]+\.)?(ucarecdn\.com|ucarecd\.net)\//i.test(URL || "");
					var Use_Browser_File_Method;

					Set_Options = Set_Options || {};
					Use_Browser_File_Method = !Use_Cdn_Method && (Set_Options.BrowserFile || Jelly.Uploadcare.Should_Load_Url_In_Browser(URL));
					this.SetSkipInitial(!!Set_Options.SkipInitial);
					this.Submitted_Internal_Id = null;
					this.Preload_Internal_Id = null;

				return this.GetApi().then(function(Api) {
					var Added_File;

					Api.removeAllFiles();

					if (Use_Cdn_Method && Api.addFileFromCdnUrl) {
						Added_File = Api.addFileFromCdnUrl(URL, {silent: true});
					}
						else if (Use_Browser_File_Method && window.fetch) {
							return window.fetch(URL, {credentials: "include"}).then(function(Response) {
								if (!Response.ok) {
									throw new Error("Could not load existing image.");
							}

							return Response.blob();
						}).then(function(Blob) {
								var File_Name = Jelly.Uploadcare.Get_File_Name_From_Url(URL, Blob);
								var File_Object = Blob;

								if (!Api.addFileFromObject) {
									throw new Error("Uploadcare cannot add browser-loaded files in this browser.");
								}

								if (typeof File == "function") {
									File_Object = new File([Blob], File_Name, {type: Blob.type || "application/octet-stream"});
								}

							Added_File = Api.addFileFromObject(File_Object, {fileName: File_Name, silent: true});
							This_Control.Preload_Internal_Id = Added_File && Added_File.internalId;

							if (Api.uploadAll) {
								Api.uploadAll();
							}

							return This_Control;
						}).catch(function(Error) {
							if (window.console && console.warn) {
								console.warn("Uploadcare could not load the existing image for recropping.", Error);
							}

							Api.removeAllFiles();
							This_Control.SetSkipInitial(false);
							return This_Control;
						});
					}
						else if (!Use_Browser_File_Method) {
						Added_File = Api.addFileFromUrl(URL, {silent: true});
						}
						else {
							if (window.console && console.warn) {
								console.warn("Uploadcare could not load the existing image in this browser.");
							}

							Api.removeAllFiles();
							This_Control.SetSkipInitial(false);
							return This_Control;
						}

					This_Control.Preload_Internal_Id = Added_File && Added_File.internalId;

					if (Api.uploadAll) {
						Api.uploadAll();
					}

					return This_Control;
				});
			}
		};

		Control.UpdateOptions(Options || {});
		$Wrapper.append($Config, $Provider, $Uploader);
		$Input.after($Wrapper);
		Control.GetApi();

		return Control;
	},

	Read_Option: function(Control, Name, Attribute_Name, Default_Value) {
		var Attribute_Value = $(Control.Input_Element).attr(Attribute_Name);

		if (typeof Control.Options[Name] != "undefined") {
			return Control.Options[Name];
		}

		if (typeof Attribute_Value != "undefined") {
			return Attribute_Value;
		}

		return Default_Value;
	},

		Apply_Config: function(Control) {
			var Source_List = Jelly.Uploadcare.Read_Option(Control, "SourceList", "data-source-list", window.WF_UPLOADCARE_SOURCE_LIST || "local, url, camera, dropbox, gdrive, facebook, gphotos, box, onedrive");
			var Accept = Jelly.Uploadcare.Read_Option(Control, "Accept", "data-accept", "image/*");
			var Image_Only = Jelly.Uploadcare.Read_Option(Control, "ImageOnly", "data-img-only", "1");
		var Crop_Preset = Jelly.Uploadcare.Read_Option(Control, "CropPreset", "data-crop-preset", "");
		var Config = Control.Config_Element;
		var Uses_Crop = Crop_Preset && Crop_Preset != "disabled";

			$(Config).attr({
				"ctx-name": Control.Context_Name,
				"pubkey": Jelly.Uploadcare.Public_Key(),
				"source-list": Source_List,
				"confirm-upload": "false",
				"locale-name": "en",
				"quality-insights": "false",
				"remove-copyright": "true"
			});
		Config.setAttribute("multiple", "false");

			if (Image_Only === true || Image_Only === "1" || Image_Only === "true") {
				$(Config).attr("img-only", "true");
				$(Config).attr("camera-modes", "photo");
				$(Config).removeAttr("accept");
			}
			else {
				$(Config).removeAttr("img-only");
				$(Config).attr("camera-modes", "photo, video");
				$(Config).attr("accept", Accept);
			}

			if (Uses_Crop) {
				$(Config).attr({
					"use-cloud-image-editor": "true",
					"cloud-image-editor-tabs": "crop",
					"crop-preset": Crop_Preset
				});
				$(Config).removeAttr("cloud-image-editor-auto-open");
			}
			else {
				$(Config).attr("use-cloud-image-editor", "false");
				$(Config).removeAttr("cloud-image-editor-tabs");
				$(Config).removeAttr("cloud-image-editor-auto-open");
				$(Config).removeAttr("crop-preset");
			}
		},

		Parse_List: function(Value, Separator) {
			if (!Value) {
				return [];
			}

			return String(Value).split(Separator).map(function(Item) {
				return $.trim(Item);
			}).filter(function(Item) {
				return !!Item;
			});
		},

		Normalize_Crop_Preset: function(Preset) {
			return $.trim(Preset || "").replace(/\s+/g, "");
		},

		Uses_Image_Editor: function(Control) {
			var Crop_Preset = Jelly.Uploadcare.Read_Option(Control, "CropPreset", "data-crop-preset", "");
			return Crop_Preset && String(Crop_Preset).toLowerCase() != "disabled";
		},

		Set_Editor_Auto_Open: function(Control, Enabled) {
			if (Enabled && Jelly.Uploadcare.Uses_Image_Editor(Control)) {
				$(Control.Config_Element).attr("cloud-image-editor-auto-open", "true");
			}
			else {
				$(Control.Config_Element).removeAttr("cloud-image-editor-auto-open");
			}
		},

		Should_Wait_For_Editor: function(Control, File_Entry) {
			var Is_Image = !File_Entry || File_Entry.isImage !== false;
			return Control.User_Flow_Active && Jelly.Uploadcare.Uses_Image_Editor(Control) && Is_Image;
		},

		Get_Crop_Label_Data: function(Control) {
			var Crop_Preset = Jelly.Uploadcare.Read_Option(Control, "CropPreset", "data-crop-preset", "");
			var Crop_Presets = Jelly.Uploadcare.Parse_List(
				Jelly.Uploadcare.Read_Option(Control, "CropPresets", "data-crop-presets", Crop_Preset),
				","
			);
			var Crop_Labels = Jelly.Uploadcare.Parse_List(
				Jelly.Uploadcare.Read_Option(Control, "CropLabels", "data-crop-labels", ""),
				"&"
			);
			var Crop_Label_Map = {};

			$.each(Crop_Presets, function(Index, Preset) {
				if (Crop_Labels[Index]) {
					Crop_Label_Map[Jelly.Uploadcare.Normalize_Crop_Preset(Preset)] = Crop_Labels[Index];
				}
			});

			return {
				Presets: Crop_Presets,
				Labels: Crop_Labels,
				Map: Crop_Label_Map
			};
		},

		Start_Decorator: function(Control) {
			var This_Control = Control;

			Jelly.Uploadcare.Stop_Decorator(Control);
			Jelly.Uploadcare.Decorate(Control);

			if (window.MutationObserver) {
				Control.Decorator_Observer = new MutationObserver(function() {
					Jelly.Uploadcare.Decorate(This_Control);
				});
				Control.Decorator_Observer.observe(Control.Uploader_Element, {
					childList: true,
					characterData: true,
					subtree: true
				});
			}

			Control.Decorator_Interval = window.setInterval(function() {
				Jelly.Uploadcare.Decorate(This_Control);
			}, 500);

			Control.Decorator_Timeout = window.setTimeout(function() {
				Jelly.Uploadcare.Stop_Decorator(This_Control);
			}, 120000);
		},

		Stop_Decorator: function(Control) {
			if (Control.Decorator_Observer) {
				Control.Decorator_Observer.disconnect();
				Control.Decorator_Observer = null;
			}

			if (Control.Decorator_Interval) {
				window.clearInterval(Control.Decorator_Interval);
				Control.Decorator_Interval = null;
			}

			if (Control.Decorator_Timeout) {
				window.clearTimeout(Control.Decorator_Timeout);
				Control.Decorator_Timeout = null;
			}
		},

		Close_Flow: function(Control) {
			Jelly.Uploadcare.Set_Editor_Auto_Open(Control, false);

			if (!Control.User_Flow_Active) {
				return;
			}

			Control.Closing_Flow = true;
			Control.User_Flow_Active = false;
			Control.GetApi().then(function(Api) {
				if (Api.doneFlow) {
					Api.doneFlow();
				}
				else if (Api.setModalState) {
					Api.setModalState(false);
				}
			});
		},

		Decorate: function(Control) {
			Jelly.Uploadcare.Attach_Editor_Events(Control);
			Jelly.Uploadcare.Decorate_Start_Dialog(Control);
			Jelly.Uploadcare.Decorate_Crop_Labels(Control);
		},

		Attach_Editor_Events: function(Control) {
			$(Control.Uploader_Element).find("uc-cloud-image-editor").each(function() {
				var Editor = this;

				if ($(Editor).data("wf-uploadcare-editor-events")) {
					return;
				}

				$(Editor).data("wf-uploadcare-editor-events", 1);

				Editor.addEventListener("change", function(Event) {
					Jelly.Uploadcare.Merge_Editor_File_Entry(Control, Event.detail || {});
				});

				Editor.addEventListener("apply", function(Event) {
					Jelly.Uploadcare.Handle_Editor_Apply(Control, Event.detail || {});
				});

				Editor.addEventListener("cancel", function() {
					Control.Pending_Editor_File_Entry = null;
					Jelly.Uploadcare.Close_Flow(Control);
					Jelly.Uploadcare.Stop_Decorator(Control);
				});
			});
		},

		Decorate_Start_Dialog: function(Control) {
			var Help_Text = Jelly.Uploadcare.Read_Option(Control, "UploadHelpText", "data-upload-help-text", "");
			var Crop_Label_Data = Jelly.Uploadcare.Get_Crop_Label_Data(Control);
			var Crop_Label_Text = Crop_Label_Data.Labels.join(", ");

			if (!Help_Text && !Crop_Label_Text) {
				return;
			}

			$(Control.Uploader_Element).find("uc-start-from .uc-content").each(function() {
				var $Content = $(this);
				var $Drop_Area = $Content.find("uc-drop-area").first();
				var $Help;

				if ($Content.find("> .wf-uploadcare-upload-help").length) {
					return;
				}

				$Help = $("<div/>")
					.addClass("wf-uploadcare-upload-help")
					.css({
						color: "#333333",
						fontSize: "14px",
						lineHeight: "1.4",
						margin: "12px 0 4px"
					});

				if (Help_Text) {
					$Help.append(
						$("<div/>").text(Help_Text)
					);
				}

				if (Crop_Label_Text) {
					$Help.append(
						$("<div/>").text("Crop options: " + Crop_Label_Text + ".")
					);
				}

				if ($Drop_Area.length) {
					$Drop_Area.after($Help);
				}
				else {
					$Content.prepend($Help);
				}
			});
		},

		Decorate_Crop_Labels: function(Control) {
			var Crop_Label_Data = Jelly.Uploadcare.Get_Crop_Label_Data(Control);
			var $Buttons;

			if (!Crop_Label_Data.Labels.length || !Crop_Label_Data.Presets.length) {
				return;
			}

			Jelly.Uploadcare.Decorate_Current_Crop_Control(Control, Crop_Label_Data);

			$Buttons = $(Control.Uploader_Element).find("uc-editor-aspect-ratio-button-control button");
			$Buttons.each(function(Index) {
				var $Button = $(this);
				var Ratio = Jelly.Uploadcare.Find_Crop_Ratio_For_Button($Button, Crop_Label_Data, Index);
				var Label = Crop_Label_Data.Map[Jelly.Uploadcare.Normalize_Crop_Preset(Ratio)];
				var Labelled_Ratio;
				var $Title;

				if (!Ratio || !Label || $Button.find(".wf-uploadcare-crop-label").length) {
					return;
				}

				Labelled_Ratio = Label + " " + Ratio;
				$Title = $Button.find(".uc-title").last();
				if ($Title.length) {
					$Title.prepend(
						$("<span/>")
							.addClass("wf-uploadcare-crop-label")
							.text(Label + " ")
					);
				}
				else {
					$Button.prepend(
						$("<span/>")
							.addClass("wf-uploadcare-crop-label")
							.text(Label + " ")
					);
				}

				$Button.attr("data-wf-uploadcare-ratio", Ratio);
				Jelly.Uploadcare.Replace_Ratio_In_Attribute($Button, "aria-label", Ratio, Labelled_Ratio);
				Jelly.Uploadcare.Replace_Ratio_In_Attribute($Button, "title", Ratio, Labelled_Ratio);
			});
		},

		Decorate_Current_Crop_Control: function(Control, Crop_Label_Data) {
			$(Control.Uploader_Element).find("uc-editor-freeform-button-control button").each(function(Index) {
				var $Button = $(this);
				var Ratio = Jelly.Uploadcare.Find_Crop_Ratio_For_Button($Button, Crop_Label_Data, Index);
				var Label = Crop_Label_Data.Map[Jelly.Uploadcare.Normalize_Crop_Preset(Ratio)];
				var Labelled_Ratio;
				var $Title;
				var Title_Text;

				if (!Ratio || !Label) {
					return;
				}

				Labelled_Ratio = Label + " " + Ratio;
				$Title = $Button.find(".uc-title").first();
				Title_Text = $.trim($Title.text());

				if ($Title.length && Title_Text.indexOf(Labelled_Ratio) == -1 && Title_Text.indexOf(Ratio) != -1) {
					$Title.text(Title_Text.replace(Ratio, Labelled_Ratio));
				}

				$Button.attr("data-wf-uploadcare-ratio", Ratio);
				Jelly.Uploadcare.Replace_Ratio_In_Attribute($Button, "aria-label", Ratio, Labelled_Ratio);
				Jelly.Uploadcare.Replace_Ratio_In_Attribute($Button, "title", Ratio, Labelled_Ratio);
			});
		},

		Find_Crop_Ratio_For_Button: function($Button, Crop_Label_Data, Index) {
			var Saved_Ratio = $Button.attr("data-wf-uploadcare-ratio");
			var Search_Text = [
				$Button.attr("aria-label") || "",
				$Button.attr("title") || "",
				$Button.text() || ""
			].join(" ");
			var Found_Ratio = "";

			if (Saved_Ratio && Search_Text.indexOf(Saved_Ratio) != -1) {
				return Saved_Ratio;
			}

			$.each(Crop_Label_Data.Presets, function(Preset_Index, Preset) {
				if (!Found_Ratio && Search_Text.indexOf(Preset) != -1) {
					Found_Ratio = Preset;
				}
			});

			return Found_Ratio || Crop_Label_Data.Presets[Index] || "";
		},

		Replace_Ratio_In_Attribute: function($Element, Attribute, Ratio, Labelled_Ratio) {
			var Value = $Element.attr(Attribute);

			if (Value && Value.indexOf(Labelled_Ratio) == -1 && Value.indexOf(Ratio) != -1) {
				$Element.attr(Attribute, Value.replace(Ratio, Labelled_Ratio));
			}
		},

		Merge_Editor_File_Entry: function(Control, File_Entry) {
			Control.Pending_Editor_File_Entry = $.extend({}, Control.Pending_Editor_File_Entry || {}, File_Entry || {});
			return Control.Pending_Editor_File_Entry;
		},

		Handle_Editor_Apply: function(Control, File_Entry) {
			var Pending_File_Entry = Jelly.Uploadcare.Merge_Editor_File_Entry(Control, File_Entry || {});

			if (!Pending_File_Entry || !Pending_File_Entry.cdnUrl) {
				return;
			}

			if (typeof Pending_File_Entry.isImage == "undefined") {
				Pending_File_Entry.isImage = true;
			}

			Control.Pending_Editor_File_Entry = null;
			Jelly.Uploadcare.Handle_File_Ready(Control, Pending_File_Entry, {Force: true});
		},

		Bind_Events: function(Control) {
		if (Control.Events_Bound) {
			return;
		}

			Control.Events_Bound = true;

			Control.Provider_Element.addEventListener("file-removed", function() {
				if (!Control.User_Flow_Active) {
					return;
				}

				var Api = Control.Provider_Element.getAPI();
				if (Api.getOutputCollectionState().totalCount != 0) {
					return;
				}

				Control.Preload_Internal_Id = null;
				Control.Submitted_Internal_Id = null;
				Control.Pending_Editor_File_Entry = null;
				Control.SetSkipInitial(false);
				Jelly.Uploadcare.Set_Editor_Auto_Open(Control, false);
				// Keep the empty list from returning to the page: choose a replacement now.
				Api.initFlow(true);
			});

			Control.Provider_Element.addEventListener("file-added", function(Event) {
				var File_Entry = Event.detail || {};
				var Preload_Internal_Id = Control.Preload_Internal_Id;

				if (Preload_Internal_Id && File_Entry.internalId != Preload_Internal_Id) {
					Control.GetApi().then(function(Api) {
						if (Api.removeFileByInternalId) {
							Api.removeFileByInternalId(Preload_Internal_Id);
						}
					});
					Control.Preload_Internal_Id = null;
					Control.SetSkipInitial(false);
				}

				Control.Submitted_Internal_Id = null;
				Control.Pending_Editor_File_Entry = null;

				if (Control.User_Flow_Active && !Control.SkipInitial && !Control.Preload_Internal_Id) {
					Jelly.Uploadcare.Set_Editor_Auto_Open(Control, true);
				}
			});

		Control.Provider_Element.addEventListener("file-upload-start", function() {
			if (Control.SkipInitial) {
				return;
			}

			if (typeof Control.Options.OnUploadStarted == "function") {
				Control.Options.OnUploadStarted(Control);
			}
		});

			Control.Provider_Element.addEventListener("file-upload-success", function(Event) {
				Jelly.Uploadcare.Handle_File_Ready(Control, Event.detail);
			});

		Control.Provider_Element.addEventListener("file-url-changed", function(Event) {
			if (Event.detail && Event.detail.isSuccess) {
					Jelly.Uploadcare.Handle_File_Ready(Control, Event.detail);
				}
			});

			Control.Provider_Element.addEventListener("modal-open", function() {
				if (Control.Closing_Flow) {
					return;
				}

				Control.User_Flow_Active = true;
				Jelly.Uploadcare.Start_Decorator(Control);
			});

			Control.Provider_Element.addEventListener("modal-close", function(Event) {
				if (Event.detail && !Event.detail.hasActiveModals && !Control.Pending_Editor_File_Entry) {
					Control.Closing_Flow = false;
					Control.User_Flow_Active = false;
					Jelly.Uploadcare.Set_Editor_Auto_Open(Control, false);
					Jelly.Uploadcare.Stop_Decorator(Control);
				}
			});
		},

		Handle_File_Ready: function(Control, File_Entry, Options) {
			var File_Info;

			Options = Options || {};

			if (!File_Entry || !File_Entry.cdnUrl) {
				return;
			}

			if (Control.SkipInitial && !Options.Force) {
				Control.SetSkipInitial(false);
				return;
			}

			if (Options.Force) {
				Control.SetSkipInitial(false);
			}

			if (!Options.Force && File_Entry.internalId && Control.Submitted_Internal_Id == File_Entry.internalId) {
				return;
			}

			if (!Options.Force && Jelly.Uploadcare.Should_Wait_For_Editor(Control, File_Entry)) {
				Jelly.Uploadcare.Merge_Editor_File_Entry(Control, File_Entry);
				Jelly.Uploadcare.Start_Decorator(Control);
				return;
			}

			Control.Submitted_Internal_Id = File_Entry.internalId;
			Control.Pending_Editor_File_Entry = null;
			Control.Preload_Internal_Id = null;
			File_Info = Jelly.Uploadcare.Create_File_Info(File_Entry);
			$(Control.Input_Element).val(File_Info.cdnUrl);
			Jelly.Uploadcare.Close_Flow(Control);

			if (typeof Control.Options.OnUploadComplete == "function") {
				Control.Options.OnUploadComplete(File_Info, Control);
			}

			Jelly.Uploadcare.Stop_Decorator(Control);
		},

	Create_File_Info: function(File_Entry) {
		return {
			uuid: File_Entry.uuid,
			name: File_Entry.name,
			size: File_Entry.size,
			mimeType: File_Entry.mimeType,
			isImage: !!File_Entry.isImage,
			cdnUrl: File_Entry.cdnUrl,
			cdnUrlModifiers: File_Entry.cdnUrlModifiers,
			crop: Jelly.Uploadcare.Parse_Crop(File_Entry)
		};
	},

	Parse_Crop: function(File_Entry) {
		var URL = File_Entry.cdnUrl || "";
		var Match = URL.match(/\/-\/crop\/(\d+)x(\d+)\//);
		var Image_Info;

		if (Match) {
			return {
				width: parseInt(Match[1], 10),
				height: parseInt(Match[2], 10)
			};
		}

		Image_Info = File_Entry.fileInfo && (File_Entry.fileInfo.imageInfo || File_Entry.fileInfo.image_info);
		if (Image_Info && Image_Info.width && Image_Info.height) {
			return {
				width: Image_Info.width,
				height: Image_Info.height
			};
		}

		return null;
	}
};
